import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Projects from '../components/sections/Projects';
import FeaturedProduct from '../components/sections/FeaturedProduct';
import Domains from '../components/sections/Domains';
import Innovation from '../components/sections/Innovation';
import Credibility from '../components/sections/Credibility';
import Internship from '../components/sections/Internship';
import PaidInternship from '../components/sections/PaidInternship';
import FinalCTA from '../components/sections/FinalCTA';
import Contact from '../components/sections/Contact';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      setTimeout(() => {
        scroller.scrollTo(location.state.scrollTo, {
          duration: 400,
          delay: 0,
          smooth: 'easeInOutQuart',
          offset: -75,
        });
      }, 50);
    }
  }, [location]);

  return (
    <>
      <Hero />
      <About />
      <Projects />
      <FeaturedProduct />
      <Domains />
      <Innovation />
      <Credibility />
      <Internship />
      <PaidInternship />
      <FinalCTA />
      <Contact />
    </>
  );
};

export default Home;
